<script setup lang="ts">
interface Props {
  modelValue: string;
  type?: "text" | "password" | "email" | "search";
  placeholder?: string;
  label?: string;
  error?: string;
  autocomplete?: string;
  required?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  type: "text",
  placeholder: "",
  label: "",
  error: "",
  autocomplete: "off",
  required: false,
});

defineEmits<{ "update:modelValue": [value: string] }>();
</script>

<template>
  <label class="field">
    <span v-if="props.label" class="label">{{ props.label }}</span>
    <input
      :type="props.type"
      :value="props.modelValue"
      :placeholder="props.placeholder"
      :autocomplete="props.autocomplete"
      :required="props.required"
      :class="['input', { 'has-error': props.error.length > 0 }]"
      @input="(e) => $emit('update:modelValue', (e.target as HTMLInputElement).value)"
    />
    <span v-if="props.error" class="error">{{ props.error }}</span>
  </label>
</template>

<style scoped>
.field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.label {
  font-family: var(--font-sans);
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--color-gray);
  text-transform: uppercase;
}
.input {
  font-family: var(--font-sans);
  font-size: 1rem;
  padding: 0.75rem 1rem;
  background: var(--color-navy-light);
  color: var(--color-cream);
  border: 1px solid rgba(232, 160, 32, 0.3);
  border-radius: 8px;
  outline: none;
  transition: border-color 0.15s ease;
  min-height: 44px;
}
.input:focus {
  border-color: var(--color-or);
}
.input.has-error {
  border-color: var(--color-danger-strong);
}
.error {
  color: var(--color-danger);
  font-size: 0.85rem;
}
</style>
